import React, { useState, useCallback } from "react";
import { SettingToggle, TextStyle, Card, Banner } from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings } from "../../actions/index";
import config from "../../config/config";
import { NotificationMajor } from "@shopify/polaris-icons";
const NotifyBuyer = () => {
	const dispatch = useDispatch();
	const dataSettings = useSelector((state) => state.dataSettings);

	const handleToggle = useCallback(() => {
		if (config.role !== "view") {
			let newNotifyBuyer = dataSettings.notify_buyer === "0" ? "1" : "0";
			let params = {
				action: "updateNotifyBuyer",
				notifyBuyer: newNotifyBuyer,
			};
			callApi("get", params, "services.php").then(function (response) {
				if (response.data.state === 1) {
					let newDataSettings = { ...dataSettings };
					newDataSettings.notify_buyer = newNotifyBuyer;
					dispatch(actFetchDataSettings(newDataSettings));
				}
			});

			let newDataSettings = { ...dataSettings };
			newDataSettings.notify_buyer = dispatch(
				actFetchDataSettings(newDataSettings)
			);
		}
	}, [dataSettings, dispatch]);

	const contentStatus =
		dataSettings.notify_buyer === "1" ? "Turn off" : "Turn on";
	const textStatus = dataSettings.notify_buyer === "1" ? "on" : "off";

	return (
		<div style={{ marginTop: "20px" }} className="notify buyer-page">
			<Banner
				status="success"
				icon={NotificationMajor}
				title="Notify Buyer"
			>
				<div className="mt-3">
					<SettingToggle
						action={{
							content: contentStatus,
							onAction: handleToggle,
						}}
						enabled={
							dataSettings.notify_buyer === "0" ? false : true
						}
					>
						Sends an email notification to the buyer via PayPal
						support email. The email contains the tracking
						information uploaded:{" "}
						<TextStyle variation="strong">{textStatus}</TextStyle>.
					</SettingToggle>
				</div>
			</Banner>
		</div>
	);
};

export default NotifyBuyer;
